function updateImageMetaTag(item) {
    const image = item.images.find(image => image.type === 'LEGER');
    const imageSrc = image?.preview.sources.find(src => src.mediaQuery === '(min-width:1200px)');
    const imagePath = imageSrc?.srcSet.src;

    if (imagePath) {
        const el = document.querySelector("meta[property='og:image']");
        el.setAttribute('content', imagePath);
    }
}

export default {
    updateImageMetaTag
}
